"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Content = exports.Checkbox = exports.SelectCheckbox = void 0;

var tslib_1 = require("tslib");

var ui_blocks_1 = require("@hopin-team/ui-blocks");

var ui_flex_1 = require("@hopin-team/ui-flex");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_props_to_styles_1 = require("@hopin-team/ui-helper-props-to-styles");

var styled_components_1 = tslib_1.__importStar(require("styled-components"));

var area = ui_blocks_1.INTERACTIVE.area,
    isInFocus = ui_blocks_1.INTERACTIVE.isInFocus,
    isInFocusInverse = ui_blocks_1.INTERACTIVE.isInFocusInverse;
var emphasis = ui_blocks_1.TYPOGRAPHY.emphasis;
var isSelected = (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  border: 0.0625rem solid transparent;\n  background-color: ", ";\n"], ["\n  border: 0.0625rem solid transparent;\n  background-color: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.BLUE["100"]', theme);
});
var isSelectedInverse = (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  border: 0.0625rem solid transparent;\n  background-color: ", ";\n"], ["\n  border: 0.0625rem solid transparent;\n  background-color: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY["900"]', theme);
});
var isInverseStyles = (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  background-color: transparent;\n  color: ", ";\n\n  &:hover {\n    background: ", ";\n    color: ", ";\n  }\n\n  &:active {\n    background-color: ", ";\n  }\n\n  &:focus-visible {\n    ", "\n  }\n"], ["\n  background-color: transparent;\n  color: ", ";\n\n  &:hover {\n    background: ", ";\n    color: ", ";\n  }\n\n  &:active {\n    background-color: ", ";\n  }\n\n  &:focus-visible {\n    ", "\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.GREY.WHITE", theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.GREY[\"700\"]", theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.GREY.WHITE", theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY["900"]', theme);
}, isInFocusInverse);
exports.SelectCheckbox = styled_components_1.default.div(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  padding: 0.5rem 0.75rem;\n  gap: 0.75rem;\n\n  ", "\n  ", "\n  border: 0.0625rem solid transparent;\n  color: ", ";\n\n  &:hover {\n    background-color: ", ";\n    border: 0.0625rem solid transparent;\n  }\n\n  &:active {\n    background-color: ", ";\n  }\n\n  &:focus-visible {\n    ", "\n  }\n\n  ", ";\n  ", "\n  ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  padding: 0.5rem 0.75rem;\n  gap: 0.75rem;\n\n  ", "\n  ", "\n  border: 0.0625rem solid transparent;\n  color: ", ";\n\n  &:hover {\n    background-color: ", ";\n    border: 0.0625rem solid transparent;\n  }\n\n  &:active {\n    background-color: ", ";\n  }\n\n  &:focus-visible {\n    ", "\n  }\n\n  ", ";\n  ", "\n  ", ";\n"])), area, emphasis, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY["800"]', theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY["200"]', theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.BLUE["100"]', theme);
}, isInFocus, function (_a) {
  var selected = _a.selected;
  return selected && isSelected;
}, function (props) {
  return (0, ui_helper_props_to_styles_1.switchStyles)(props, 'isInverse', isInverseStyles);
}, function (_a) {
  var selected = _a.selected,
      isInverse = _a.isInverse;
  return selected && isInverse && isSelectedInverse;
});
exports.Checkbox = styled_components_1.default.div(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  min-width: 1rem;\n  height: 1rem;\n  border: 0.0625rem solid\n    ", ";\n  border-radius: ", ";\n"], ["\n  min-width: 1rem;\n  height: 1rem;\n  border: 0.0625rem solid\n    ", ";\n  border-radius: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY["400"]', theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('LINE.RADIUS.MEDIUM', theme);
});
exports.Content = (0, styled_components_1.default)(ui_flex_1.Flex)(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n  flex-grow: 1;\n  text-overflow: ellipsis;\n  overflow: hidden;\n"], ["\n  flex-grow: 1;\n  text-overflow: ellipsis;\n  overflow: hidden;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;